import ouiBase from '@goldwasserexchange/oui';
import { useAccountCashflowFieldApiByCpsHisId } from '../api';

export const useAccountCashflowsCCurrencyCode = () => {
  const cpsHisId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountCashflowFieldApiByCpsHisId({
    cpsHisId,
    field: 'C_CURRENCY.CODE',
  });
  return result;
};
